import React from "react";
// import Button from "../../components/ui/Button";
import { withdrawalsApi } from "../../api/withdrawals";
import { useAuth } from "../../context/AuthContext";
import { format } from "date-fns";
import { Button } from "flowbite-react";
import Swal from "sweetalert2";

export default function WithDrawRequestCard({
  id,
  amount,
  status,
  receiverName,
  note,
  User,
  receiverMobileNumber,
  createdAt,
  approvedNotes,
  onStatusChange,
  userId,
  outlet,
}) {
  const { tokens, user } = useAuth();

  const isFlagged = Boolean(User?.flagged);

  const formattedAmount = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const handleApproveReject = async (action) => {
    try {
      if (action === "approve" && isFlagged) {
        const { value: confirmed } = await Swal.fire({
          icon: "warning",
          title: "Flagged account",
          text: "This request is from a flagged account. Double-check the details before approving.",
          showCancelButton: true,
          confirmButtonText: "Continue",
          confirmButtonColor: "#dc2626",
          customClass: {
            popup: "font-poppins",
          },
        });

        if (!confirmed) {
          return;
        }
      }

      const { value: notes } = await Swal.fire({
        title: `Enter notes for ${action}`,
        input: "text",
        inputLabel: "Notes",
        inputPlaceholder: "Enter your notes here...",
        inputAttributes: {
          "aria-label": "Enter your notes here",
        },
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "Notes cannot be empty!";
          }
        },
        customClass: {
          popup: "font-poppins",
          title: "text-lg font-semibold",
          input: "rounded-lg p-2.5",
          confirmButton:
            "bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg",
          actions: "gap-3",
        },
      });

      if (notes) {
        const apiAction =
          action === "approve"
            ? withdrawalsApi.approveWithdrawal
            : withdrawalsApi.declineWithdrawal;

        await apiAction(tokens.access.token, id, notes);
        // Refresh the withdrawals list
        if (typeof onStatusChange === "function") {
          onStatusChange(); // Now this only triggers refresh without params
        }
      }
    } catch (error) {
      console.error(`Failed to ${action} withdrawal:`, error);
    }
  };

  return (
    <div
      className={`p-4 border rounded-lg ${
        isFlagged ? "bg-red-50 border-red-300" : "bg-white border-[#E1E7EF]"
      }`}
    >
      <div className="flex justify-between items-start mb-4">
        <span className="text-2xl font-bold text-[#0E64D1]">₱{formattedAmount}</span>
        <div className="flex items-center gap-2">
          {isFlagged && (
            <span className="px-3 py-1 rounded-full text-sm bg-red-600 text-white">
              Flagged
            </span>
          )}
          <span
            className={`px-3 py-1 rounded-full text-sm ${
              status === "pending"
                ? "bg-[#FFE771] text-[#733F12]"
                : status === "approved"
                ? "bg-[#85EFAC] text-[#114C29]"
                : "bg-red-300 text-red-900"
            }`}
          >
            {status.charAt(0).toUpperCase() + status.slice(1)}
          </span>
        </div>
      </div>

      <div className="space-y-3">
        <div>
          <div className="text-xs font-normal text-[#65758B]">
            Reference No.
          </div>
          <div className="text-sm font-medium">#{id}</div>
        </div>

        <div>
          <div className="text-xs font-normal text-[#65758B]">Request From</div>
          <div className="text-sm font-medium">{User?.name}</div>
        </div>

        <div>
          <div className="text-xs font-normal text-[#65758B]">
            Receiver Name
          </div>
          <div className="text-sm font-medium">{receiverName}</div>
        </div>

        <div>
          <div className="text-xs font-normal text-[#65758B]">Mobile No.</div>
          <div className="text-sm font-medium">{receiverMobileNumber}</div>
        </div>

        <div>
          <div className="text-xs font-normal text-[#65758B]">Date</div>
          <div className="text-sm font-medium">
            {format(new Date(createdAt), "MMM dd, yyyy hh:mm a")}
          </div>
        </div>

        {outlet && (
          <div>
            <div className="text-xs font-normal text-[#65758B]">Withdrawal Type</div>
            <div className={`text-xs font-medium px-3 py-1 rounded-full inline-block ${
              outlet === "Maya" 
                ? "bg-[#35F2A1] text-[#114C29]" 
                : outlet === "GCash" 
                ? "bg-[#0979EF] text-white"
                : "bg-gray-200 text-gray-800"
            }`}>{outlet}</div>
          </div>
        )}

        <div>
          <div className="text-xs font-normal text-[#65758B]">Note</div>
          <div className="text-sm font-medium">{note}</div>
        </div>

        {userId !== user.id && (
          <>
            {status === "pending" && (
              <div className="flex gap-2 mt-4">
                <Button
                  color="blue"
                  onClick={() => handleApproveReject("approve")}
                >
                  Approve
                </Button>
                <Button
                  color="dark"
                  onClick={() => handleApproveReject("reject")}
                >
                  Reject
                </Button>
              </div>
            )}

            {approvedNotes && (
              <div>
                <div className="text-xs font-normal text-[#65758B]">
                  {status === "approved" ? "Approved Notes" : "Rejected Notes"}
                </div>
                <div className="text-sm font-medium">{approvedNotes}</div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
